(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.web.view 
  (:require [frontend.ui.component.chart.view :as chart]
            [frontend.ui.component.grid.view :as grid]
            [frontend.ui.component.lp-portal.card.view :as card]
            [frontend.ui.component.lp-portal.report.component.block-table.view :as block-table]
            [frontend.ui.component.lp-portal.report.component.horizontal-table.view :as horizontal-table]
            [frontend.ui.component.lp-portal.report.component.map.controller :refer [map-view]]
            [frontend.ui.component.lp-portal.report.module.chart-card :as chart-card]
            [frontend.ui.component.lp-portal.report.module.free-text-card :as free-text-card]
            [frontend.ui.component.lp-portal.tabbed-card.view :refer [tabbed-card]] 
            [frontend.ui.component.lp-portal.section.view :as section] 
            [frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.titles :as titles]))

(defn natural-capital-view
  [{:keys [fund-ui-data language] :as props}]
  (let [{:keys [basic-information nav-per-unit-series unit-value total-return-by-unit-series
                portfolio-allocation portfolio-by-country-fair-value investments-map
                fund-update-1 fund-update-2 sustainability-text-1 sustainability-text-2 sustainability-text-3]} fund-ui-data]
    [:div
     [:div
      [section/section
       ""
       nil
       [:div
        [grid/row {}
         [grid/column {:large 6}
          [block-table/table (titles/resolve-dasos-titles-with-lang :basic-information language) basic-information props]]
         [grid/column {:large 6}
          [chart-card/view (titles/resolve-dasos-titles-with-lang :unit-value language) unit-value 
           (assoc props :hide-footnote? false)]]]
        [grid/row {}
         [grid/column {:large 6}
          [horizontal-table/table (titles/resolve-dasos-titles-with-lang :nav-per-unit-series language) nav-per-unit-series props]]
         [grid/column {:large 6}
          [horizontal-table/table (titles/resolve-dasos-titles-with-lang :total-return-by-unit-series language) total-return-by-unit-series props]]]]]

      [section/section
       ""
       nil
       [tabbed-card
        {:selected :portfolio-allocation}
        [{:id    :portfolio-allocation
          :title (titles/resolve-dasos-titles-with-lang :portfolio-allocation language)
          :body ^{:key :portfolio-allocation}
          [:<>
           [chart/chart portfolio-allocation]]}
         {:id    :portfolio-at-fair-value
          :title (titles/resolve-dasos-titles-with-lang :portfolio-by-country-fair-value language)
          :body ^{:key :portfolio-by-country-fair-value}
          [:<>
           [chart/chart portfolio-by-country-fair-value]]}
         {:id    :investments-map
          :title (titles/resolve-dasos-titles-with-lang :investments-map language)
          :body ^{:key :investments-map}
          [:<>
           [map-view investments-map "" props]]}]]]

      [card/card {:title ""}
       [grid/row {}
        [grid/column {}
         [free-text-card/free-text-section "" fund-update-1 props]]
        [grid/column {}
         [free-text-card/free-text-section "" fund-update-2 props]]]]
      [card/card {}
       [:div {:style {:display "flex"
                      :flex-direction "column"
                      :gap "10px"}}
        [grid/row {}
         [grid/column {:large 12}
          [free-text-card/free-text-section "" sustainability-text-1 props]]]
        [grid/row {}
         [grid/column {}
          [free-text-card/free-text-section "" sustainability-text-2 props]]
         [grid/column {}
          [free-text-card/free-text-section "" sustainability-text-3 props]]]]]]]))
